import script from "./CampaignDialAttemptsPanel.vue?vue&type=script&setup=true&lang=js"
export * from "./CampaignDialAttemptsPanel.vue?vue&type=script&setup=true&lang=js"

import "./CampaignDialAttemptsPanel.vue?vue&type=style&index=0&id=d2292048&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d2292048"]])

export default __exports__